/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import { getIsUrbanFlag } from 'views/urban-dashboard/utils/formatters';
import UrbanDashboard from 'views/urban-dashboard/UrbanDashboard';

/**
 * DashboardRouter — Conditional wrapper that renders either the
 * Urban Dashboard or the existing dashboard based on the IsUrban
 * localStorage flag.
 *
 * The flag is read at render time (no state/useEffect) so it evaluates
 * on each navigation without requiring a full page reload.
 *
 * Requirements: 1.1, 1.2, 1.3, 1.4, 1.5, 1.6
 *
 * @param {object} props
 * @param {'distributor' | 'super-distributor'} props.userRole - The user's role
 * @param {React.ComponentType} props.ExistingDashboard - The existing dashboard component to render when IsUrban is not active
 */
function DashboardRouter({ userRole, ExistingDashboard }) {
    const isUrban = getIsUrbanFlag();
    return isUrban ? <UrbanDashboard role={userRole} /> : <ExistingDashboard />;
}

DashboardRouter.propTypes = {
    userRole: PropTypes.oneOf(['distributor', 'super-distributor']).isRequired,
    ExistingDashboard: PropTypes.elementType.isRequired
};

export default DashboardRouter;
